// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};